import { render, staticRenderFns } from "./shangpin.vue?vue&type=template&id=0dfc1ca5&"
import script from "./shangpin.vue?vue&type=script&lang=js&"
export * from "./shangpin.vue?vue&type=script&lang=js&"
import style0 from "./shangpin.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports